import Container from "../ui/Container";
import SectionHeader from "../ui/SectionHeader";
import TestimonialCard from "./TestimonialCard";

export default function Testimonials() {
    const testimonials = [
        { name: "Ravi Kumar", feedback: "Got my home loan approved in just 3 days. Excellent service!" },
        { name: "Meena Sharma", feedback: "Transparent process and quick support team." },
        { name: "Arun Prasad", feedback: "Best interest rates and easy EMI calculator." },
    ];

    return (
        <section id="testimonials" className="py-16 bg-gray-100">
            <Container>
                <SectionHeader title="What Our Clients Say" />
                <div className="grid md:grid-cols-3 gap-6">
                    {testimonials.map((t, i) => (
                        <TestimonialCard key={i} name={t.name} feedback={t.feedback} />
                    ))}
                </div>
            </Container>
        </section>
    );
}
